import React from 'react';
import { useSelector } from 'react-redux';
import RightPanel from './rightPanel';
import CenterPanel from './centerPanel';
import PopupHeader from '../../popupHeader';
import Modal from '../../../shared/modal/content';

const ContentChangePassword = (props) => {
  const resetingPassword = useSelector((state) => state.usersReducer.resetingPassword);
  const userEmailForPasswordReset = useSelector((state) => state.usersReducer.userEmailForPasswordReset);
  const showModal = useSelector((state) => state.modalReducer.showChangePasswordModal);
  const changePassword = useSelector((state) => state.usersReducer.changePassword);
  const userEmail = useSelector((state) => state.usersReducer.userProfile.email);

  return (
    <Modal show={showModal} hideWhenClickAway={false} className="ui modal reset-password">
      <PopupHeader
        helpLink={APP.EXTERNAL_LINKS.MyProfile.ChangePassword}
        title={APP.LANGUAGE.ResetPassword.ChangePasswordTitle}
      />

      <div className="content">
        <div className="main-ui-container user-reset-password">
          <div id="righthandfloatingpanel">
            <div className="right ui rail">
              <div className="ui sticky ">
                <RightPanel resetingPassword={resetingPassword} userEmail={userEmail} changePassword={changePassword} />
              </div>
            </div>
            <CenterPanel changePassword={changePassword} userEmail={userEmail} />
            <div className="bottom-rail-with-left-and-right-content mrtl ">
              <RightPanel resetingPassword={resetingPassword} userEmail={userEmail} changePassword={changePassword} />
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default ContentChangePassword;
